export default __webpack_public_path__ + "static/media/nsc-img4.90641dd9.png";